import React from 'react';

interface DisplayNameProps {
  displayName: string;
}

const DisplayName: React.FC<DisplayNameProps> = ({ displayName }) => {
  const firstName = displayName.split(' ')[0];
  const firstLetter = firstName.charAt(0).toUpperCase();
  
  return (
    <div className="flex items-center space-x-2 min-w-0">
      <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
        {firstLetter}
      </div>
      <span className="text-white font-medium truncate">{firstName}</span>
    </div>
  );
};

export default DisplayName;
